import { Link } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";
import { REVIEWS } from "../../data/reviews";

const FEATURED = REVIEWS.filter((r) => ["alison", "richard", "yvonne"].includes(r.id));

export const Reviews = () => (
  <section className="py-16 sm:py-24 lg:py-32" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <p className="eyebrow">Kind words</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#292A26] tracking-tight mt-4" data-testid="reviews-heading">
            In their own words.
          </h2>
        </div>
        <Link
          to="/reviews"
          data-testid="read-more-reviews-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-[#3F4A38] group"
        >
          Read More Reviews
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {FEATURED.map((r) => (
          <figure
            key={r.id}
            data-testid={`review-card-${r.id}`}
            className="bg-white rounded-3xl border border-[#DDD7CB] p-8 flex flex-col hover:border-[#3F4A38]/40 transition-colors"
          >
            <Quote className="w-6 h-6 text-[#D8B7B0]" />
            <blockquote className="mt-5 text-[0.95rem] leading-relaxed text-[#292A26] flex-1">
              {r.excerpt}
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-[#E7E2D8]">
              <p className="text-sm font-semibold text-[#292A26]">{r.attribution}</p>
              <p className="mt-1 text-xs uppercase tracking-[0.16em] text-[#B9A58D] font-medium">{r.relation} · {r.source}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
